import axios from 'axios';
import HttpRequestsUtility from './HttpRequestsUtility';
class BucketService {
  static uploadSingleFile(baseUrl, onProgress = null) {
    let url = `${!baseUrl || baseUrl === '/' ? '' : baseUrl}/uploadFile/`;
    if (window.location.host.includes('localhost')) {
      // To handle localhost development
      url = 'http://localhost:5007/v1/bulk-upload/uploadAssetObject';
    }
    return (file, path, projectId) => {
      const formData = new FormData();
      formData.append('path', path);
      formData.append('project', projectId);
      formData.append('file', file);
      return axios.post(url, formData, HttpRequestsUtility.getMultipartAxiosConfig(onProgress));
    };
  }
  static uploadMultipleFile(baseUrl, onProgress = null) {
    let url = `${!baseUrl || baseUrl === '/' ? '' : baseUrl}/uploadFileZip/`;
    if (window.location.host.includes('localhost')) {
      // To handle localhost development
      url = 'http://localhost:5007/v1/bulk-upload/createAssetsFromZipCMS';
    }
    return (file, path, projectId) => {
      const formData = new FormData();
      formData.append('path', path);
      formData.append('project', projectId);
      formData.append('file', file); // zip file

      return axios.post(url, formData, HttpRequestsUtility.getMultipartAxiosConfig(onProgress));
    };
  }
  static uploadMultipleFileWithThumbs(baseUrl, onProgress = null) {
    let url = `${!baseUrl || baseUrl === '/' ? '' : baseUrl}/uploadFileZipWithThumbs/`;
    if (window.location.host.includes('localhost')) {
      // To handle localhost development
      url = 'http://localhost:5007/v1/bulk-upload/createAssetsFromZipCMS?withThumbs=true';
    }
    return (file, path, projectId) => {
      const formData = new FormData();
      formData.append('path', path);
      formData.append('project', projectId);
      formData.append('file', file); // zip file

      return axios.post(url, formData, HttpRequestsUtility.getMultipartAxiosConfig(onProgress));
    };
  }

  // static uploadFile(base64, path, dataType) {
  //     return fetch(REACT_APP_APOLLO_URI + "/createBucketObject", {
  //         method: 'POST',
  //         headers: HttpRequestsUtility.getAuthorizedHeaders(),
  //         body: JSON.stringify({
  //           objectData: base64,
  //           objectName: path,
  //           objectDataType: dataType,
  //           project: {
  //             id: ""
  //           }
  //         })
  //     });
  // }
}

export default BucketService;